@if (items$ | async; as items) {
<div class="search-empty-wrapper">
  <div class="container">
    <label>{{ title$ | async }}</label>
    @if (items.length > 0) {
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
      @for (item of items; track item; let i = $index) {
      <div ngxSlickItem class="slide">
        @if (item | async; as data) {
        <div class="item">
          <a
            tabindex="0"
            [routerLink]="{ cxRoute: 'product', params: data } | cxUrl"
            (click)="gtmProductClick(data, i + 1)"
          >
            <div class="prod-image">
              <div>
                <cx-media
                  [container]="getImageRendition(data?.images?.PRIMARY)"
                  format="product"
                  [class.is-missing-fish]="businessType === 'fish'"
                  removeImageTitleAttr
                ></cx-media>
              </div>
            </div>
            <div class="prod-body">
              <div class="prod-code">{{ data.code }}</div>
              <div class="prod-name">{{ data.name }}</div>
              <div class="prod-price">
                <ng-container>
                  @if (!showSrp) {
                  <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                  <span class="p-price">
                    @if (!dealerPrice(data.code)) {
                    <div class="spinner-shimano-wrapper-dp">
                      @if (this.hasDealerPrice) {
                      <div class="spinner-shimano">
                        <div></div>
                      </div>
                      } @if (!this.hasDealerPrice) {
                      <div class="no-dealer-price no-dealer-price-alt"></div>
                      }
                    </div>
                    } @else {
                    {{ dealerPrice(data.code) }}
                    }
                  </span>
                  } @if (showSrp) {
                  <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                  <span class="p-price">
                    {{ data.srpPrice?.formattedValue }}
                  </span>
                  }
                </ng-container>
              </div>
            </div>
          </a>
          <div class="prod-bottom container">
            <div class="row">
              <div class="col-sm-6">
                <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
                  <mat-icon class="material-icons-sharp light">assignment</mat-icon>
                </a>
              </div>
              <div class="col-sm-6">
                <a tabindex="0" class="order-form" href="#">
                  <mat-icon class="material-icons-sharp light">note_add</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </ngx-slick-carousel>
    }
  </div>
</div>
}
